import { render, staticRenderFns } from "./InspectionRecord.vue?vue&type=template&id=28a53768&scoped=true&"
import script from "./InspectionRecord.vue?vue&type=script&lang=js&"
export * from "./InspectionRecord.vue?vue&type=script&lang=js&"
import style0 from "./InspectionRecord.vue?vue&type=style&index=0&id=28a53768&lang=scss&scoped=true&"
import style1 from "./InspectionRecord.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a53768",
  null
  
)

export default component.exports